import {Action} from '@ngrx/store';
import {RoleArcgis} from "../../../../../core";

export enum RolesArcgisActionTypes {
  LOAD_REQUEST = '[ROLES_ARCGIS] Load Request',
  LOAD_FAILURE = '[ROLES_ARCGIS] Load Failure',
  LOAD_SUCCESS = '[ROLES_ARCGIS] Load Success',
}

// load
export class RolesArcgisLoadRequestAction implements Action {
  readonly type = RolesArcgisActionTypes.LOAD_REQUEST;
}

export class RolesArcgisLoadFailureAction implements Action {
  readonly type = RolesArcgisActionTypes.LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class RolesArcgisLoadSuccessAction implements Action {
  readonly type = RolesArcgisActionTypes.LOAD_SUCCESS;

  constructor(public payload: { items: RoleArcgis[] }) {
  }
}

// actions

export type RolesArcgisActions =
  | RolesArcgisLoadRequestAction
  | RolesArcgisLoadFailureAction
  | RolesArcgisLoadSuccessAction;
